import { User } from '../models';

export const isAdmin = (user: User): boolean => user.roles.includes('ROLE_ADMIN');

export const isResponsable = (user: User) => {
    if (user.roles.includes('ROLE_RESPONSABLE')) return true;
    return false;
};

export const isAllowedToManagContent = (user: User) => {
    if (user.roles.includes('ROLE_ADMIN_DOCUMENT')) return true;
    return false;
};

export const hasRole = (user: User, roles: string[]) => {
    if (user.roles.includes('ROLE_ADMIN')) return true;
    for (let i = 0; i < roles.length; ++i) {
        if (user.roles.includes(roles[i])) return true;
    }
    return false;
};

export const hasFunctionality = (user: User, features: string[]): boolean => {
    if (!features || !user.features) return true;
    for (let i = 0; i < features.length; ++i) {
        if (user.features.includes(features[i])) return true;
    }
    return false;
};

export const isVisitor = (user: User) => {
    return user.roles.includes('ROLE_VISITOR') && !user.roles.includes('GROUP_BACKOFFICE_ROLES');
};

export const isVisitorBackOffice = (user: User): boolean => {
    const isVisitor = user.roles.includes('ROLE_VISITOR');
    const isInBackOfficeGroup = user.roles.includes('GROUP_BACKOFFICE_ROLES');

    return isVisitor && !isInBackOfficeGroup;
};
